import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryASRActions } from "../../../../store/external/inventory/asr.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import '../../../common/report/reports/Invoice/invoice-table.component.css';
import ButtonIcon from "../../../button";
import { CustomColumns } from "../../../common/modal-popover/custom-columns";
import Filter from "../../../common/filter/filter.component";
import '../../inventory/inventory-component.css'
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { TRANSLATIONS as translation } from "../../../../utils/constant.utils";
class InventoryASR extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox=this.DisplaySearhBox.bind(this)
        this.openLineItem=this.openLineItem.bind(this)

        this.state = {
            modifyColTitle: '',
            extractInventoryTitle: '',
            searchTitle: '',
            tableSelected:false,
            closeForm:false,
            rowId:"0",
            pageNumber:0,
			viewType:'list',
            displaySearch:false,
            selectedIndex:0,
            dataSelected:[],
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Subscription Details"
                    },
                    {
                        "id":"1",
                        "label":"Usage Spend"
                    }
                ]
            },
            historyList:[]
        }
     }

    componentDidMount() {
        this.props.getInventoryASR();
    }
    componentWillUnmount(){
        this.props.setResetSearch();
        this.props.resetInventoryASRData();
    }
    DisplaySearhBox() {
        this.setState({displaySearch:!this.state.displaySearch})
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    CloseForm(data) {
        this.setState({tableSelected:data})
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
        
    }

    resizePage = (value) => {
        const { getInventoryASR, resizeInventoryASRPage } = this.props;
        resizeInventoryASRPage(value);
        getInventoryASR();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onClickExtract = (e) => {
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            this.props.extractInventoryASR();
        }
    };

    loading = () => {
        return (
           <NoSubscription />
        );
    }

    applyFilter = (isApply) => {
        const { getInventoryASR, applyInventoryASRFilter } = this.props;
        applyInventoryASRFilter(isApply);
        isApply && getInventoryASR(0);
    }

    render() {

        const { inventoryASR, getInventoryASR, sortInventoryASRItems, setInventoryASRColSearchStr, addInventoryASRFilter, removeInventoryASRFilter, saveInventoryASRCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.inventoryASR.inventoryASRItems.Columns;
        let isExtractNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASRRE, ACCESS_MODULE.InventoryASRRW])
        let isFilterNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASRR, ACCESS_MODULE.InventoryASRRE, ACCESS_MODULE.InventoryASRRW])
        let isSearchNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASRR, ACCESS_MODULE.InventoryASRRE, ACCESS_MODULE.InventoryASRRW])
        let isCustomizedNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASRR, ACCESS_MODULE.InventoryASRRE, ACCESS_MODULE.InventoryASRRW])
        let isShowTableNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASRR, ACCESS_MODULE.InventoryASRRE, ACCESS_MODULE.InventoryASRRW])
        
        return(
                <div className="invoice-wrapper-container inventory-report-component" >
                    <RequestHeaders headerTitle="asr" />              
                        <div className="request-table data-table fit-width">
                            {
                                !isFilterNotAllowed && <Filter data={inventoryASR.inventoryASRItems.TableFilterData} addAction={addInventoryASRFilter} removeAction={removeInventoryASRFilter} applyAction={this.applyFilter}  />
                            }
                            {!isFilterNotAllowed && <div className="horizontal-separator"></div>}
                            <div className="container-filter-button">
                                {!isSearchNotAllowed && <ButtonIcon onClick={this.DisplaySearhBox} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>}
                                {!isCustomizedNotAllowed && <CustomColumns defaultList={Default} firstList={Available} secondList={Selected} saveAction={saveInventoryASRCustomCols} />}
                                {!isExtractNotAllowed && <ButtonIcon onClick={(e)=> this.onClickExtract(e)} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Extract List"/>}
                            </div>                       
                            {
                                this.props.inventoryASR.isInventoryASRLoaded ? 
                                !isShowTableNotAllowed && <TablePagination  
                                    key={TABLE_PAGINATION_KEY.inventoryASR} 
                                    classNameWrapper="overflow-auto" 
                                    columns={inventoryASR.inventoryASRItems.Headers}
                                    pageList={inventoryASR.inventoryASRItems.Data}
                                    pages={inventoryASR.inventoryASRItems.Pagination}
                                    rowClickAction={() => { }}
                                    paginationAction={getInventoryASR}
                                    onColumnClick={sortInventoryASRItems}
                                    onColumnSearch={() => {getInventoryASR(0) }}
                                    onColumnSearchChange={setInventoryASRColSearchStr}
                                    isColSearchShow={this.state.displaySearch} 
                                    resizePage={this.resizePage}
                                    totalPage={inventoryASR.inventoryASRItems.Pagination.TotalEntries}
                                />
                                : this.loading()
                            } 
                        
                        </div>                
            </div>
        )
    }
}

export default connect(
    state => {
        const { inventoryASR, translation } = state;

        return {
            inventoryASR,
            ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryASRActions),
        dispatch
    )
) (InventoryASR);
